module.exports = __webpack_public_path__ + "img/Grus.603eb278.png";